import { render, staticRenderFns } from "./blog-5.vue?vue&type=template&id=cb595382&scoped=true"
import script from "./blog-5.vue?vue&type=script&lang=js"
export * from "./blog-5.vue?vue&type=script&lang=js"
import style0 from "./blog-5.vue?vue&type=style&index=0&id=cb595382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb595382",
  null
  
)

export default component.exports